(function () {
  'use strict';
  document.querySelectorAll('.managed-inspiration').forEach(function (section) {
    var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
    var previousScroll = window.scrollY;
    var strength = 1;
    var scheduled = false;

    function updateBackground() {
      scheduled = false;
      var currentScroll = window.scrollY;
      var delta = currentScroll - previousScroll;
      previousScroll = currentScroll;
      var bounds = section.getBoundingClientRect();
      if (reducedMotion.matches) {
        strength = 1;
      } else if (bounds.bottom > 0 && bounds.top < window.innerHeight) {
        // Fade on upward scrolling; restore the blue when scrolling down.
        strength = Math.max(0, Math.min(1, strength + delta / Math.max(300, window.innerHeight * 0.75)));
      }
      section.style.setProperty('--inspiration-blue-opacity', strength.toFixed(3));
    }

    window.addEventListener('scroll', function () {
      if (!scheduled) {
        scheduled = true;
        window.requestAnimationFrame(updateBackground);
      }
    }, { passive: true });
    reducedMotion.addEventListener('change', updateBackground);

    section.querySelectorAll('[data-inspiration-filter]').forEach(function (button) {
      button.addEventListener('click', function () {
        section.querySelectorAll('[data-inspiration-filter]').forEach(function (tab) {
          tab.classList.toggle('active', tab === button);
          tab.setAttribute('aria-pressed', String(tab === button));
        });
        section.querySelectorAll('[data-inspiration-groups]').forEach(function (card) {
          card.hidden = !card.dataset.inspirationGroups.split(' ').includes(button.dataset.inspirationFilter);
        });
      });
    });
  });
})();
